import { findRecursive } from '@/mm/utils.js'
import { washDataArabic, washDataArabicAlign, ArabicEach } from '@/mm/utils.js'

export function washData_relatedCarouselNews(walkedNode) {
  if (walkedNode._type === 'related_carousel_news1') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    const buttonNode = findRecursive(
      walkedNode.list,
      (item) => item._type === 'button_text_1',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode) {
      if (!buttonNode.actions.find((item) => item === 'translate')) {
        buttonNode.actions.push('translate')
      }
    }
    let ArabicRule = [
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'more',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: ['self_marginLeft'],
        englishTitleRight: ['self_marginRight'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'related_carousel_news2') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    const buttonNode = findRecursive(
      walkedNode.list,
      (item) => item._type === 'button_text_1',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode && !buttonNode.actions.find((item) => item === 'translate')) {
      buttonNode.actions.push('translate')
    }
    let ArabicRule = [
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'date',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'more',
        dataType: ['design','design'],
        onlyEnglish: ['self_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)

  } else if (walkedNode._type === 'related_carousel_news3') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    let ArabicRule = [
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'date',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'related_carousel_news4') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    const buttonNode = findRecursive(
      walkedNode.list,
      (item) => item._type === 'button_text_1',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode && !buttonNode.actions.find((item) => item === 'translate')) {
      buttonNode.actions.push('translate')
    }
    let ArabicRule = [
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'date',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'more',
        dataType: ['design','design'],
        onlyEnglish: ['self_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  }
}
